import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import ColorDivider from "@edaz/edazkit/ColorDivider";
import Header from "@edaz/edazkit/Header";
import Icon, { IconType } from "@edaz/edazkit/Icon";
import LoaderOverlay from "@edaz/edazkit/LoaderOverlay";
import { observer } from "mobx-react-lite";
import React from "react";
import InitializationService from "../services/initializationService";

const initializationView: ViewComponent<InitializationService> = observer(({ vm }) => {
  return (
    <>
      <ColorDivider />
      <Header
        bg="white"
        expand="lg"
        containerWrap={true}
        containerFluid="md"
        className="shadow-sm mb-2"
        brand={<Icon icon={IconType.Edaz} width={60} height={60} className="mr-1 mr-md-2" />}
      />
      <LoaderOverlay loading={true} style={{ minHeight: "calc(100vh - 100px)" }} />
    </>
  );
});

registerView(initializationView, InitializationService);
